/** Attach parentComponent titles from parent_modification_id (API snake_case shape). */
export function mapModificationsWithParent<T extends { id: string | number; parent_modification_id?: number | null }>(
  rawMods: T[]
): (T & { parentComponent?: string; cost?: number })[] {
  return rawMods.map((mod) => {
    if (mod.parent_modification_id) {
      const parent = rawMods.find((p) => p.id === mod.parent_modification_id);
      return {
        ...mod,
        parentComponent: parent ? (parent as { title?: string }).title : undefined,
        cost: 0,
      };
    }
    return mod;
  });
}
